var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TemplateBasic',{attrs:{"breadcrumb":_vm.breadcrumb,"permission":_vm.permission}},[_c('embed',{staticStyle:{"width":"100%","height":"75vh"},attrs:{"src":"https://docs.google.com/gview?embedded=true&url=https://pbills.parkaidemobile.com/static/pdf/ParkBills_FAQs.pdf"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c4ceeb56","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Page/User/PageFAQ.vue
// module id = null
// module chunks = 